import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminQueueStatusResponse } from '@utils/types/admin';

/**
 * Hook to fetch RabbitMQ queue status
 *
 * GET /api/admin/on-prem/queue
 *
 * Returns queue depths, consumers, message rates
 */
export const useGetAdminQueue = () => {
  const fetchQueue = async () => {
    const url = `api/admin/on-prem/queue`;
    const response = await Axios.get<AdminQueueStatusResponse>(url);
    return response.data;
  };

  return useQuery<AdminQueueStatusResponse, AxiosError<BaseError>>(
    ['adminQueue'],
    fetchQueue,
    {
      useErrorBoundary: false,
      refetchInterval: 15000 // Auto-refresh every 15 seconds
    }
  );
};
